const defaultMeta = {
    title: 'PhotoStudio® AI',
    description: 'PhotoStudio® AI致力于极低成本、极高效率满足商业拍摄需求',
    keywords: 'psai,photostudioai,ai商拍,ai电商图'
}

export const seoRouteList = [
    {
        route: '/',
        title: 'PSAI - 虹软AI智能商拍服务平台',
        description: 'PSAI提供商拍图一站式服务：AI模特、换背景、试衣、视频在线生成全覆盖，并提供服装商拍图成品交付方案，帮助电商快速上新、稳定出图、降低成本，让视觉内容生产更高效更省心。',
        keywords: 'AI商拍, AI商业拍摄, 商品图生成, AI模特, 电商视觉, 服装商拍, AI换模特, AI换背景, AI试衣, 商品图制作, 电商主图, 种草图, AI视频生成, 虹软PSAI, PhotoStudio AI, 商拍图成品交付, 商拍服务, 电商内容生成'
    },
    {
        route: '/homePageMaster',
        title: 'AI商拍成片交付服务 - 虹软AI智能商拍服务平台',
        description: 'PSAI成片交付服务融合AI生成能力与专业视觉团队支持，为电商商家提供从需求到成片的一站式交付，快速完成商品图、种草图与视频内容制作，降低拍摄成本并提升上新效率。',
        keywords: '成片交付服务,服装成片,童装品牌AI商拍,女装品牌AI商拍,男装品牌AI商拍,AI商拍服务,商品图交付,电商视觉服务,AI商拍团队,商品制作,种草制作,AI视频生成服务,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/homePageMasterSub',
        query: { type: 'kid' },
        title: '童装AI商拍成片交付服务 - 虹软AI智能商拍服务平台',
        description: 'PSAI童装AI商拍成片交付服务，融合AI生成与专业视觉团队能力，为童装品牌提供从需求到成片的一站式交付，快速完成童装主图、种草图与视频制作，降低拍摄成本并提升上新效率。',
        keywords: '童装AI商拍,童装商品图制作,童装拍摄服务,AI商拍服务,童装种草图,童装模特图生成,电商童装图制作,成片交付服务,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/homePageMasterSub',
        query: { type: 'woman' },
        title: '女装AI商拍成片交付服务 - 虹软AI智能商拍服务平台',
        description: 'PSAI女装AI商拍成片交付服务，通过AI生成与专业视觉能力，帮助女装品牌高效完成装主图、种草图与视频内容制作，提升上新效率与转化效果，实现电商视觉内容产能升级。',
        keywords: '女装AI商拍,女装成片交付服务,女装商拍解决方案,女装商品图制作,AI商拍服务,女装种草图,穿搭内容生成,电商女装视觉,模特图生成,服装成片,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/homePageMasterSub',
        query: { type: 'male' },
        title: '男装AI商拍成片交付服务 - 虹软AI智能商拍服务平台',
        description: 'PSAI男装AI商拍成片交付服务，通过AI生成与专业视觉能力，帮助男装品牌高效完成装主图、搭配图、种草图与视频内容制作，提升上新效率与视觉表现，实现电商内容产能升级。',
        keywords: '男装AI商拍,男装成片交付服务,男装商拍解决方案,男装商品图制作,AI商拍服务,男装模特图生成,电商男装视觉,男装搭配图,男装种草图,服装成片,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/clothes',
        title: 'AI试衣-虚拟试衣与服装上身在线生成 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI AI试衣功能支持虚拟试穿与服装上身效果生成，无需真人模特即可完成服装展示。通过AI模特、换模特与姿势生成功能，帮助电商快速产出高质量试衣图，提升上新效率与转化表现。',
        keywords: 'AI试衣,虚拟试衣,AI试穿,在线试衣,服装试衣AI,AI模特试衣,电商试衣,服装上身效果生成,上身效果生成,AI模特,服装展示生成,虹软PSAI,PhotoStudio AI,电商视觉生成'
    },
    {
        route: '/home/homemain/simTryon',
        title: '同版型试衣-多模特同版上身效果一键生成 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI同版型试衣支持同一服装在不同模特上的上身效果生成，无需重复拍摄即可实现多款身材、多个体展示。帮助电商统一版型表达，提升商品展示丰富度与转化效率。',
        keywords: '同版型试衣,AI试衣,多模特试衣,同款试穿,AI模特试衣,版型上身效果,电商试衣图,AI换模特,服装展示图生成,批量试衣,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/model',
        title: '换模特-AI一键替换商拍图模特 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI换模特功能支持在不改变服装版型的前提下，一键替换不同模特，生成多风格商品图。无需重新拍摄，帮助电商快速扩展展示内容，降低成本并提升转化效果。',
        keywords: '换模特,AI换模特,模特替换,AI模特生成,电商模特替换,服装换模特,商品图生成,AI商拍,虹软PSAI,PhotoStudio AI,电商视觉生成'
    },
    {
        route: '/home/homemain/background',
        title: '换背景-一键替换服饰场景图 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI服装换背景支持一键生成多种服饰展示场景，包括白底图与生活场景图，无需搭景拍摄即可完成高质量商品图制作，帮助商家提升视觉表现与转化效率。',
        keywords: '服装换背景,衣服换背景,AI换背景,服装场景图生成,商品图换背景,电商服装图片处理,白底图生成,场景图生成,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/shoesTryon',
        title: '鞋子上脚-AI生成真实上脚效果图 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI鞋子上脚功能支持在线生成真实自然的上脚效果图，无需真人拍摄即可展示鞋款穿着效果。适用于电商详情页、主图与种草内容制作，帮助商家提升点击率与转化表现。',
        keywords: '鞋子上脚,AI鞋子上脚,上脚效果图,鞋子试穿,AI试鞋,鞋子展示图,电商鞋类商拍,上脚图生成,商品图生成,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/glassesTryon',
        title: '眼镜试戴-眼镜虚拟试戴与佩戴效果在线生成 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI眼镜试戴支持在线生成真实自然的佩戴效果，无需真人拍摄即可完成不同脸型与风格的试戴展示。适用于电商商品页与种草内容制作，帮助提升点击率与购买转化。',
        keywords: '眼镜试戴,AI试戴眼镜,虚拟试戴,眼镜佩戴效果,在线试戴眼镜,眼镜AI试戴,电商眼镜展示,眼镜上脸效果,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/necklaceTryon',
        title: 'AI 项链虚拟试戴 | 珠宝佩戴效果图生成 - 虹软PSAI智能商拍服务平台',
        description: '虹软 PSAI 在线 AI 项链虚拟试戴工具，一键生成项链真人佩戴效果图，自动匹配肤色、颈部光影，无需模特实拍，适配银饰、黄金、钻石、轻奢珠宝电商出图，快速产出高清首饰上身展示素材。',
        keywords: 'AI 项链试戴，虚拟项链试戴，珠宝虚拟试戴，首饰试戴效果图，项链上身图生成，电商珠宝试戴，饰品 AI 上身，珠宝商拍工具，虹软 PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/poseTryon',
        title: '姿势裂变-一键生成多姿势服饰展示图 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI姿势裂变功能支持基于单张素材生成多种模特姿势动作，无需重复拍摄即可扩展商品展示效果。帮助电商丰富视觉内容，提升商品表现力与转化率。',
        keywords: '姿势裂变,AI姿势生成,多姿势商拍图,AI模特姿势,姿势扩展,电商展示图生成,AI商拍,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/clothRecolor',
        title: '服饰换色-在线一键换色扩展SKU展示 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI服饰换色支持在保持版型与材质细节的前提下，一键生成多颜色商品图，无需重拍，帮助商家快速扩展SKU展示，提升上新效率与商品转化表现。',
        keywords: '服饰换色,AI换色,衣服换颜色,商品换色,电商换色图,多颜色商品图,AI服装生成,SKU扩展,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/fusionWear',
        title: '搭配上身-AI智能生成服饰搭配与上身效果图 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI搭配上身支持智能生成爆款穿搭效果图，实现多单品组合上身展示。无需真人拍摄即可完成服饰搭配与种草内容创作，帮助电商提升商品表现力与转化效率。',
        keywords: '搭配上身,穿搭生成,AI穿搭,服装搭配图,上身效果图,穿搭展示,爆款穿搭,服饰穿搭生成,爆款穿搭展示,AI试衣,电商穿搭图,种草图生成,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/flatlay3d',
        title: '平铺图转3D图 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI 支持在线将商品平铺图一键转换成 3D 立体效果图，自动还原服饰、商品立体结构与光影质感，无需建模软件，适配服装电商、饰品静物、服装平铺白底图三维化出图，快速生成商用高清 3D 展示素材，一站式电商 AI 商拍工具。',
        keywords: '平铺图转 3D 图，AI 生成 3D 效果图，商品图 3D 化，电商平铺图三维转换，服装平铺图转立体图，AI 三维建模，商品 3D 渲染，虹软 PSAI,PhotoStudio AI,智能商拍'
    },
    {
        route: '/home/homemain/creativeToImage',
        title: 'AI 创意设计 | 生成服装创意效果图 - 虹软 PSAI 智能商拍服务平台',
        description: '虹软 PSAI AI 创意设计功能，支持输入文字描述或上传参考图，一键生成各类服饰服装效果图，自由定制服装款式、版型、面料与场景，无需实景拍摄，高效产出电商服装宣传、平铺、上身商用视觉素材。',
        keywords: 'AI 创意设计，文字生成服装图，图片生成服饰效果图，AI 服装生图，服饰图文创作，电商服装 AI 绘图，服装创意出图，服饰款式生成，虹软 PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/grassPlant',
        title: '种草图-一键生成高引流的场景图 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI种草图支持在线生成多场景引力的服装展示效果图，通过AI模特、AI场景生成能力，帮助商家快速产出种草内容，提升点击率与转化率。',
        keywords: '种草图,AI种草图,商品种草图,电商种草内容,种草图生成,服装种草图,服饰种草图,户外种草图,室内种草图,AI商拍,内容电商,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/commodity',
        title: '商品换背景-一键替换商品图背景 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI商品换背景功能支持一键替换商品图背景，生成白底图、电商场景图等多种风格，无需实拍即可完成高质量视觉内容制作，帮助商家提升商品展示效果与转化表现。',
        keywords: '换背景,AI换背景,图片换背景,商品图换背景,电商背景生成,AI背景替换,白底图生成,场景图生成,AI商拍,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/commodityRecolor',
        title: '商品换色-一键在线为商品图换色 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI商品换色支持在保持产品结构与细节的前提下，一键生成多颜色商品图，无需重拍。适用于服装、鞋包、3C、家居等多品类电商，帮助提升上新效率与转化表现。',
        keywords: '商品换色,AI换色,产品换颜色,多颜色商品生成,电商换色,SKU图片生成,AI商品图生成,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/watermarkRemove',
        title: '去抹除-一键智能去除抹除不留痕 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI图片去抹除功能基于AI智能修复技术，可一键去除图片中的抹除、文字、logo及杂物，并自动补全背景细节，适用于电商商品图、海报及营销素材处理，效果自然无痕。',
        keywords: '去抹除,图片去抹除,AI去抹除,去抹除工具,去logo,去文字,去遮挡,电商图片处理,商品图去抹除,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/model_video',
        title: '动作模仿-AI视频生成-参考动作一键生成爆款视频 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI AI视频生成支持动作模仿与迁移，可基于参考视频复刻人物动作，生成自然流畅的视频内容，适用于电商种草视频、广告内容制作，大幅提升视频生产效率。',
        keywords: 'AI视频生成,动作模仿,动作复制,图生视频,视频生成AI,AI动作迁移,姿势模仿,电商视频生成,模特动作生成,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/homemain/model_video_img',
        title: '图生视频-AI视频生成-一张图片生成商品视频 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI图生视频功能支持将商品图片一键生成动态视频，根据描述自动补充动作与镜头变化，适用于电商展示、种草视频与广告内容制作，无需拍摄即可快速生成高质量视频素材。',
        keywords: '图生视频,图片生成视频,AI视频生成,图片转视频,AI商品视频,图转视频,电商视频生成,商品视频制作,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/product/batchImages',
        title: 'PSAI企业版 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI企业版支持批量生图能力。',
        keywords: 'AI商拍,AI商业拍摄,商品图生成,AI模特,电商视觉,服装商拍,AI换模特,AI换背景,AI试衣,商品图制作,电商主图,种草图,AI视频生成,虹软PSAI,PhotoStudio AI,商拍图成品交付,商拍服务,电商内容生成'
    },
    {
        route: '/home/image_extraction',
        title: '智能抠图-AI编辑-精准抠图一键去背景 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI智能抠图支持在线一键去除图片背景，精准识别人像与主体，实现发丝级抠边处理，适用于电商商品图、人像图及广告素材制作，快速生成高质量透明背景图。',
        keywords: '智能抠图,AI抠图,一键抠图,自动去背景,图片抠图工具,商品抠图,电商抠图,人像抠图,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/aiEdit',
        query: { menuKey: 'imageFiner' },
        title: 'AI超清-AI图片编辑-一键提升图片清晰度与细节表现 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI AI超清功能支持在线一键提升图片清晰度，增强边缘细节与纹理表现，适用于电商商品图、人像图及广告素材的高质量输出场景。',
        keywords: 'AI超清,图片超清,AI高清修复,图片清晰度增强,图片细节增强,AI图片编辑,电商图片优化,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/aiEdit',
        query: { menuKey: 'imageResize' },
        title: '高清改尺寸-AI编辑-无损放大与图片尺寸调整 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI高清改尺寸功能支持图片无损放大与尺寸调整，在放大过程中自动去噪并控制细节损失，适用于电商商品图、海报及广告素材的多尺寸输出需求。',
        keywords: '高清改尺寸,图片改尺寸,AI放大图片,无损放大,图片尺寸调整,图片缩放不失真,电商图片尺寸,商品图尺寸处理,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/aiEdit',
        title: 'AI图片编辑-手部修复-魔法擦除-智能补光-模特美化 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI AI图片编辑功能集手部修复、魔法擦除、智能补光、智能抠图与模特美化能力，针对电商图片细节进行智能优化，让商品图更自然、更清晰、更具转化力。',
        keywords: 'AI图片编辑,手部修复,魔法擦除,智能补光,AI美化,图片精修,AI修图工具,电商图片优化,商品图精修,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/aiedit',
        title: 'AI图片编辑-手部修复-魔法擦除-智能补光-模特美化 - 虹软PSAI智能商拍服务平台',
        description: 'PSAI AI图片编辑功能集手部修复、魔法擦除、智能补光、智能抠图与模特美化能力，针对电商图片细节进行智能优化，让商品图更自然、更清晰、更具转化力。',
        keywords: 'AI图片编辑,手部修复,魔法擦除,智能补光,AI美化,图片精修,AI修图工具,电商图片优化,商品图精修,虹软PSAI,PhotoStudio AI'
    },
    {
        route: '/home/myProject/list',
        title: '我的项目 - 虹软PSAI智能商拍服务平台',
        description: '我的项目 - 虹软PSAI智能商拍服务平台',
        keywords: 'AI商拍,AI商业拍摄,商品图生成,AI模特,电商视觉,服装商拍,AI换模特,AI换背景,AI试衣,商品图制作,电商主图,种草图,AI视频生成,虹软PSAI,PhotoStudio AI,商拍图成品交付,商拍服务,电商内容生成'
    },
    {
        route: '/connect_us',
        title: '关于PSAI - 虹软PSAI智能商拍服务平台',
        description: 'PSAI是虹软为电商打造的AI智能商拍服务平台，旨在为商家提供一站式商品图生成与成片交付服务。',
        keywords: 'AI商拍,AI商业拍摄,商品图生成,AI模特,电商视觉,服装商拍,AI换模特,AI换背景,AI试衣,商品图制作,电商主图,种草图,AI视频生成,虹软PSAI,PhotoStudio AI,商拍图成品交付,商拍服务,电商内容生成'
    }
]

const matchQuery = (ruleQuery, currentQuery) => {
    if (!ruleQuery) return true
    return Object.keys(ruleQuery).every((key) => currentQuery.get(key) === String(ruleQuery[key]))
}

export const resolveRouteMeta = (pathname, search = '') => {
    const query = new URLSearchParams(search)
    const hit =
        seoRouteList.find((item) => item.route === pathname && item.query && matchQuery(item.query, query)) ||
        seoRouteList.find((item) => item.route === pathname && !item.query)

    return {
        title: hit?.title || defaultMeta.title,
        description: hit?.description || defaultMeta.description,
        keywords: hit?.keywords || defaultMeta.keywords
    }
}
